riot.tag2('bbc-notifications-settings', '<header id="notifications__header" class="notifications__header notifications__header--js"> <h2 class="notification-title notification-title--js"><i1-8n>Notifications Settings</i1-8n></h2> <ul class="notification-header-icons"> <li> <a href="javascript:;" class="notifications__settings__back-btn--js" onkeydown="{this.onBackKeydown}" onclick="{this.parent.closeSettings}" role="link" title="Go back" alt="Go back" aria-label="Go back"><img class="setting-icon notifications-image" riot-src="{this.parent.basePath + \'/svg/arrow_left_black.svg\'}" alt="back"><span class="notifications-brevier"><i1-8n>Back</i1-8n></span></a> </li> </ul> </header> <div class="notifications-settings-description"> <p class="notifications-long-primer"><i1-8n>copy.settings</i1-8n></p> </div> <div each="{this.products}" class="notifications-settings-item notifications-settings-product--js" role="checkbox" aria-checked="{enabled}"> <label tabindex="0" onkeydown="{this.onLabelKeydown}"> <div class="notifications-long-primer notifications-settings-text">{this.getProductSettingLabel(product)}</div> <input type="checkbox" name="checkbox" id="{product}-settings-checkbox" class="notifications-settings-tickbox" value="{product}" __checked="{enabled}" onchange="{this.productChange}"> <div class="notifications-settings-checkbox-hold"></div> </label> </div>', '', '', function(opts) {
'use strict';

var _this = this;

var notificationsAnalytics = require('../analytics');
var userPreferences = require('../models/UserPreferences');
var i18n = require('riot-i18n');

this.friendlyProductNames = userPreferences.friendlyProductNames;

this.getProductSettingLabel = function (type) {
    return i18n.localise('{product} Notifications', { //eslint-disable-line
        product: _this.friendlyProductNames[type]
    });
};

this.updatePref = function (item, box) {
    item.enabled = box.checked;

    console.log('Product change', item, box.checked);

    userPreferences.set({
        preferences: {
            lastReadFlag: false,
            productsEnabled: _this.products
        }
    }).catch(function (err) {
        box.checked = !box.checked;

        item.enabled = box.checked;

        _this.parent.parent.error.inner = 'settings';
        _this.parent.parent.update();
        notificationsAnalytics.log('error4-settings-fail', 'notifications-error');
        throw err;
    }).then(function () {
        console.info('Pref update succeeded');

        notificationsAnalytics.log(item.enabled ? 'opt-in' : 'opt-out', 'notifications-settings', {
            nots_product: item.product.toLowerCase()
        });

        _this.parent.parent.resetNotifications();
    });
};

this.productChange = function (e) {
    console.log('Product change event', e);
    _this.updatePref(e.item, e.currentTarget);
};

this.onBackKeydown = function (e) {
    if (e.keyCode === 9 && e.shiftKey) {
        // Tab forwards
        document.querySelector('.notifications-settings-product--js:last-child label').focus();
        return false;
    } else if (e.keyCode === 13) {
        // Enter
        _this.parent.updateFocus = '.notifications__settings--js';
    }

    return true;
};

this.onLabelKeydown = function (e) {
    if (e.keyCode === 9 && !e.shiftKey) {
        // Tab backwards
        var next = document.activeElement.parentNode.nextSibling;
        var endOfList = !(next.classList && next.classList.contains('notifications-settings-product--js'));

        if (endOfList) {
            document.querySelector('.notifications__settings__back-btn--js').focus();
            return false;
        }
    } else if (e.keyCode === 13) {
        // Enter
        var box = e.currentTarget.querySelector('input');
        console.log('Enter on label', box);
        box.checked = !box.checked;

        _this.updatePref(e.item, box);

        return false;
    }

    return true;
};

this.on('mount', function () {
    var pref = userPreferences.get();
    _this.products = pref.preferences.productsEnabled;

    console.log('Settings products', _this.products);
});
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/components/bbc-notifications-settings.tag
 ** module id = 27
 ** module chunks = 0
 **/